import { prop } from "vue-class-component";

export class FileUploadComponentHandlerProps {
  category: string = prop({ required: true });
  entity: string = prop({ required: true });
  subCategory: string = prop({ required: true });
}